import { createGlobalStyle } from 'styled-components';

const systemFonts = 'system-ui, -apple-system, BlinkMacSystemFont, San Francisco, Roboto, Segoe UI, Helvetica Neue, sans-serif';
const typographyFontFamily = `'Open Sans', ${systemFonts}`;

// eslint-disable-next-line no-unused-vars
export const GlobalStyle = createGlobalStyle`
  html,
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;

    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }
  }

  body {
    font-family: ${systemFonts};
  }

  body.fontLoaded {
    font-family: ${typographyFontFamily};

    input, textarea, select, button {
      font-family: inherit;
    }

    input, textarea {
      -webkit-user-select:text;
    }
  }

  body.is-dragging {
    user-select: none;
    cursor: grabbing;
  }

  .material-icons {
    display: none;
  }

  .material-icons.fontLoaded {
    display: inline-block;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
    height: 100%;
  }
`;

// throw new Error(
//   'An injectGlobal usage was converted to createGlobalStyles via codemod but needs to be hooked up. See https://www.styled-components.com/docs/api#createglobalstyle for instructions.'
// );
